import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";

function Accordion({ faqs }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderedFaqs = faqs.map((faq, index) => {
    const isActive = index === activeIndex;

    return (
      <div
        key={faq.question}
        className="border border-main-dark pt-4 px-8 cursor-pointer"
        onClick={() => handleAccordionClick(index)}
        onKeyUp={(e) => e.key === "Enter" && handleAccordionClick(index)}
        tabIndex={0}
        role="button"
      >
        <div className="flex justify-between gap-4 pb-4">
          <h5 className="text-main-dark text-xl md:text-2xl font-copy">
            {faq.question}
          </h5>
          <span className="text-main-dark text-xl md:text-2xl font-copy">
            {isActive ? "-" : "+"}
          </span>
        </div>
        <div
          className={`border-t border-main-dark overflow-hidden transition-all duration-500 ease-in-out ${
            isActive ? "opacity-100 max-h-40 py-4" : "opacity-0 max-h-0"
          }`}
        >
          <p className="text-main-dark">{faq.answer}</p>
        </div>
      </div>
    );
  });

  return (
    <div className="flex flex-col gap-4 w-full [&_*]:transition-all [&_*]:duration-300">
      <Fade direction="right" triggerOnce>
        {renderedFaqs}
      </Fade>
    </div>
  );
}

export default Accordion;
